import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { AuthProvider } from './contexts/AuthContext';
import App from './App';
import './index.css';

/* Visaly n'a plus qu'un seul thème (« Cream & Ink », clair). On purge les
   classes laissées sur <html> par l'ancien sélecteur de thème, et la clé de
   stockage associée : sans ça, un compte qui était en sombre ou en shader
   garderait des variantes actives au premier chargement. */
document.documentElement.classList.remove('dark', 'shader');
localStorage.removeItem('visaly-theme');

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    sendDefaultPii: false,
    tracesSampleRate: 0,
    integrations: [],
    beforeSend(event) {
      if (event.user) {
        delete event.user.ip_address;
        delete event.user.email;
      }
      return event;
    },
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<div>Une erreur est survenue. Rechargez la page.</div>}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
